import {IconButton, Typography } from "@mui/material";
import { Box } from "@mui/material";
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';

function AgentsHeader({setViewAgents}) {
    return (
        <Box
          sx={{
            p: 2,
            top: 0,
            backgroundColor: "#085E56",
            borderRadius: "15px 15px 0px 0px ",
            position: "sticky",
            display: "flex",
            flexDirection: "row",
            justifyContent: "left",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display:'flex',
              flexDirection:'column',
              alignItems:'left'
            }}
          >
            <Typography
              sx={{
                fontFamily:'DM Sans Bold',
                fontSize: "24px",
                color: "#FFFFFF",
              }}
            >
              Hello !
            </Typography>
            <Typography
                sx={{
                fontFamily:'DM Sans Medium',
                fontSize: "14px",
                color: "#FFFFFF",
              }}
            >
            Any Questions? feel free to chat with our agents
            </Typography>
          </Box>
          <IconButton
            disableRipple
            disableFocusRipple
            disableTouchRipple
            sx={{ml:'auto',color:'#FFFFFF'}}
            onClick={()=>{setViewAgents(false)}}
          >
            <ChevronLeftRoundedIcon/>
          </IconButton>
        </Box>
      );
}

export default AgentsHeader